(function (window) {
  'use strict';

  var SIZES = {24: 'avatar--24', 40: 'avatar--40', 64: 'avatar--64'};
  var BADGES = {
    verified: {icon: 'material-symbols:verified', cls: 'badge-icon--verified', label: 'js.badge.verified'},
    reviewed: {icon: 'material-symbols:check-circle-rounded', cls: 'badge-icon--reviewed', label: 'js.badge.reviewed'},
    partner: {icon: 'material-symbols:verified', cls: 'badge-icon--partner', label: 'js.badge.partner'},
    caution: {icon: 'material-symbols:warning-rounded', cls: 'badge-icon--caution', label: 'js.badge.caution'}
  };

  function esc(value) { return window.JN.esc(value == null ? '' : String(value)); }
  function t(key) { return window.JN.t(key); }
  function data(o) { return ' data-line="' + esc(JSON.stringify(o)) + '"'; }

  function badge(o, pop) {
    var b = BADGES[o.badge];
    if (!b) return '';
    var label = esc(t(b.label));
    var icon = '<iconify-icon icon="' + b.icon + '" aria-hidden="true"></iconify-icon>';
    var cls = 'avatar__badge ' + b.cls;
    if (!pop) return '<span class="' + cls + '" role="img" aria-label="' + label + '">' + icon + '</span>';
    return '<button type="button" class="btn-unstyled ' + cls + ' js-badge-sheet" aria-label="' + label + '" title="' +
      label + '"' + data(o) + '>' + icon + '</button>';
  }

  function avatar(o, size, pop) {
    var photo = o.photo && o.photo.sm
      ? '<img src="' + esc(o.photo.sm) + '" alt="" loading="lazy" class="avatar__img">'
      : '<span class="avatar__initials" aria-hidden="true">' + esc(o.initials) + '</span>';
    return '<span class="avatar ' + SIZES[size] + (o.square ? ' avatar--square' : '') + '">' + photo +
      badge(o, pop !== false) + '</span>';
  }

  function pill(o) {
    return o.client && o.badge === 'caution' ? '<span class="pill caution">' + esc(t('js.badge.caution')) + '</span>' : '';
  }

  function trust(o) {
    if (!o.client) return '';
    if (o.badge === 'caution') {
      return '<button type="button" class="btn-unstyled pill caution js-badge-sheet"' + data(o) + '>' +
        esc(t('js.badge.caution')) + '</button>';
    }
    var head = t({verified: 'js.badge.verified', partner: 'js.badge.partner'}[o.badge] || 'js.badge.not_verified');
    return '<button type="button" class="trust-line js-badge-sheet"' + data(o) + '>' + esc(head) +
      (o.org_type ? ' · ' + esc(o.org_type) : '') +
      '<iconify-icon icon="ph:caret-right" class="rtl:tw-rotate-180" aria-hidden="true"></iconify-icon></button>';
  }

  function line(o, size, pop) {
    var top = o.top_rated ? ' <iconify-icon icon="mdi:crown-outline" class="tw-ms-1 tw-align-[-2px] tw-text-primary-text" aria-hidden="true"></iconify-icon>' : '';
    var loc = size >= 40 && o.location ? '<span class="identity-line__sub" dir="auto">' + esc(o.location) + '</span>' : '';
    return '<span class="identity-line' + (size === 24 ? ' identity-line--24' : '') + '">' + avatar(o, size, pop) +
      '<span class="tw-min-w-0"><span class="identity-line__name" dir="auto">' + esc(o.name) + top + '</span>' +
      (size >= 40 ? trust(o) : '') + loc + '</span></span>';
  }

  window.JN = window.JN || {};
  window.JN.identityLine = { avatar: avatar, line: line, pill: pill, trust: trust };
})(window);
